import script from "./TopSearchOptionSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./TopSearchOptionSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./TopSearchOptionSkeleton.vue?vue&type=style&index=0&id=7002c12f&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7002c12f"]])

export default __exports__